import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { useFormik } from "formik";
import { createColumns, confirmDelete, sortArrayNumProp, emptyArray } from "../../../redux/utils";
import { SortableList, CustomProperties, UnsortableList } from "../";
import { CustomGridProperties } from "../objects";
import { useSnackContext } from "../../contexts/Snack";


export const TabFormOqt = (props) => {
  

  const loadList = () => {
    try{
      return item[name] ? sortArrayNumProp(item[name], order) : item[name]
    }catch(e){
      console.log({item, name, order})
      console.log(e);
      return emptyArray;
    }
  }

  const { devMode, details, section, name, caption, data, item, rootValues, order = "no_order", maxWidth = "md", variant = "outlined", auto_reload = false } = props;
  const [ state, setState ] = useState(()=>({open: false, values: {}, list: loadList(), newId: 0, isNew: false, changeOrder: 0}));
  const [ fields, setFields ] = useState([]);
  const [ valid, setValid ] = useState(false);
  const { openAxiosError } = useSnackContext();
  
  useEffect(()=>{
    setState(state => ({...state, list: loadList()}));
  }, [item[name]])

  useEffect(()=>{
    if(state.changeOrder>0){
      //console.log(state.list)
      state.list.forEach(item =>
        data.editItem(item.id, item, section)
      )
    }
  }, [state.changeOrder])

  const newItemValues = () => {
    return {
      ...fields.reduce((p, c) => ({...p, [c.name]: c.defaultValue && eval(c.defaultValue)({item, data, name, caption, fields})}), {}),
      [order]: state.newId,
    } 
  };

  useEffect(() => {
    data.getSchema(section).then(response => {
      setFields(response.fields)
    })
    //console.log({order, l1: item[name],l2:state.list, l3: item[name].sortByNumProp(order)})
  }, [])

  const fmk = useFormik({
    initialValues: {},
    validationSchema: props.validationSchema && props.validationSchema.innerType,
    onSubmit: values => {
      handleClose();
      const parentField = fields.find(x => x.type === "parentId");
      const nextOrder = state.list.reduce((prev, curr) => curr[order] > prev ? curr[order] : prev, 0) + 1;
      
      const newItem = {...values, [parentField.name]: item.id, [order]: nextOrder}
      const fn = state.isNew ? () => data.addItem(newItem, section) : () => data.editItem(newItem.id, newItem, section);
      fn()
        .then(response=>{
          setState((prev) => {
            const list = (
              prev.isNew 
                ? [...prev.list ? prev.list : [], response] 
                : prev.list.map(x => x.id === response.id ? response : x)
              );
            return {...prev, list, newId: prev.isNew ? prev.newId - 1 : prev.newId};
          });
          fmk.setValues({});
        })
        .catch(error => {
          openAxiosError(error)
        })
    }
  })
  
  const handleSubmit = () => {
    fmk.validateForm()
    .then( () => {
      fmk.submitForm();
    })
    .catch( error => {
      console.log(error)
    });
  }

  const handleChangeValues = (values) => {
    //console.log("ObjectList handleChangeValues");
    fmk.setValues(values);
  }

  const handleClose = () => {
    setState({...state, open: false});
  }

  const handleOpen = () => {
    setState({...state, open: true});
  }

  const handleEditClick = ({row}, event) => {
    event && event.preventDefault();
    fmk.setValues(row);
    setState({...state, open: true, values: row, isNew: false});
  }

  const handleDeleteClick = ({row}) => {
    const primaryText = columns
    .filter(x => x.field !== "acciones")
    .map(c => c.renderCell ? c.renderCell({row, extraData: data}) : ( item ? item[c.field] : "" ) )
    .filter(x => x !== ""); 
    confirmDelete({
      html: "Está seguro de eliminar este elemento?"
    }).then(()=>{
      data.removeItem(row, section)
        .then(response=>{
          //console.log(response);
          setState((prev) => {
            const list = prev.list.filter(x => x.id !== response.id);
            return {...prev, list, changeOrder: order === "no_order" ? prev.changeOrder : prev.changeOrder + 1};
          })
        })
        .catch(error => {
          openAxiosError(error)
        })
    })

  }

  const handleAddItem = () => {
    setState({...state, open: true, values: newItemValues(), isNew: true});
  }

  const handleReorderList = (list) => {
    setState((prev) => {
      //formik.setFieldValue(name,);
      const newList =  list.map((x, index) => ({...x, [order]: index}));
      return {...prev, list: newList, changeOrder: prev.changeOrder + 1};
    })
  }

  const columns = createColumns({fields, disabled: details})({onEdit: handleEditClick, onDelete: handleDeleteClick});

  return (
    <div style={devMode ? {margin: 0} : {margin: "8px"}}>

      {variant == "outlined" && caption}
      {
        order === "no_order"
          ? <UnsortableList   
              devMode={devMode}
              data={data}
              details={details}
              rows={state.list} 
              columns={columns}
              addItem={<Button fullWidth variant="text" onClick={handleAddItem}>Agregar</Button>}
            />
          : <SortableList   
              devMode={devMode}
              data={data}
              details={details}
              onReorderList={handleReorderList} 
              rows={state.list} 
              columns={columns}
              addItem={<Button fullWidth variant="text" onClick={handleAddItem}>Agregar</Button>}
            />
      }
      
      <Dialog fullWidth onClose={handleClose} open={state.open} keepMounted={false} maxWidth={maxWidth}>
        <DialogTitle>{state.isNew ? `Agregar item en ${caption.toLowerCase()}` : `Editar item en ${caption.toLowerCase()}`} </DialogTitle>
        <DialogContent>
          <CustomGridProperties onValidChange={setValid} validationSchema={props.validationSchema && props.validationSchema.innerType} {...{data, name, item, fields: fields.filter(f => f && !f.hidden), rootValues}} initialValues={state.values} onChange={handleChangeValues} />
          <DialogContentText>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button disabled={!valid} onClick={handleSubmit} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

}